// extracted by mini-css-extract-plugin
export default {"form":"RenameFolderTemplate_form__9Pwh0","actions":"RenameFolderTemplate_actions__l4R1m","button":"RenameFolderTemplate_button__yY1j-"};